var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sliding-list"},[_c('PersonList',{attrs:{"persons":_vm.persons},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var person = ref.person;
return [_vm._t("default",null,{"person":person})]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }